module.exports = __webpack_public_path__ + "img/29.4fb2d7ac.jpg";